import React, { FC, useState } from 'react';
import { CreateFormula, Formula } from '../../../types';
import { Button, TextField } from '@mui/material';
import { L } from 'harmony-language';

interface EditCreateFormulaProps {
    existingFormula: Formula | null;
    addFormula: (data: CreateFormula) => void;
    editFormula: (data: Formula) => void;
    closeModal: () => void;
}

export const EditCreateFormula: FC<EditCreateFormulaProps> = (props) => {
    const { existingFormula, addFormula, editFormula, closeModal } = props;
    const [formula, setFormula] = useState<CreateFormula | Formula>(existingFormula || {
        name: '',
    });

    const submitForm = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if ('id' in formula) {
            editFormula(formula);
        } else {
            addFormula(formula);
        }

        closeModal();
    }

    return (
        <div style={{ minWidth: '20vw' }}>
            <form id='edit-create-formula-form' name='edit-create-formula-form' onSubmit={submitForm}>
                <TextField
                    label={L.name()}
                    variant='standard'
                    value={formula.name}
                    onChange={(e) => setFormula(formula => ({ ...formula, name: e.target.value }))}
                    fullWidth
                    required
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
                    <Button
                        type='submit'
                        title={L.save()}
                        variant='contained'
                        color='primary'
                    >
                        {existingFormula ? L.updateFormula() : L.createFormula()}
                    </Button>
                </div>
            </form>
        </div>
    );
};
